import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowTop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.29295 10.293C4.90243 10.6835 4.90243 11.3165 5.29295 11.707C5.68348 12.0975 6.31651 12.0975 6.70702 11.707L11 7.41406V19C11 19.5523 11.4477 20 12 20C12.5522 20 13 19.5523 13 19V7.41406L17.293 11.707C17.6835 12.0975 18.3165 12.0975 18.707 11.707C19.0975 11.3165 19.0975 10.6835 18.707 10.293L12.707 4.29297C12.6759 4.26183 12.6424 4.23418 12.6084 4.20801C12.5905 4.19423 12.5725 4.18053 12.5537 4.16797C12.5147 4.14195 12.4741 4.11956 12.4326 4.09961C12.387 4.07767 12.3401 4.05788 12.291 4.04297C12.2743 4.0379 12.2571 4.03445 12.2402 4.03027C12.1632 4.01125 12.0829 4.00001 12 4C11.9203 4 11.8428 4.00974 11.7685 4.02734C11.748 4.03221 11.7273 4.03678 11.707 4.04297C11.6583 4.05787 11.6117 4.07777 11.5664 4.09961C11.5266 4.11877 11.4877 4.1403 11.4502 4.16504C11.3935 4.20242 11.3408 4.24516 11.293 4.29297L5.29295 10.293Z",
		fill: "currentColor"
	})
});
export default SvgArrowTop;
